import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { NotificationService } from './../../services/notification.service';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-my-colleges',
  templateUrl: './my-colleges.component.html',
  styleUrls: ['./my-colleges.component.scss']
})
export class MyCollegesComponent implements OnInit, OnDestroy {
  collegeJsonData = [];
  myCollegeStatusJSON = [];
  housingPlanJSON = [];
  studentUserId: any;
  classYearDescription;
  dataLoaded = false;
  pageNo = 1;
  studentId: number;
  totalItems = 0; // variable to store total items
  saveDataFlag = false;
  pageSize = 50;
  sort = 'MyFit Score';
  subs: Subscription[] = [];
  @ViewChild('modal') modelVal;
  myFitValue: any;

  constructor(
    private notificationService: NotificationService,
    private _commonAuthService: CommonAuthenticationService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private _commonDataSharedService: CommonDataSharedService
  ) { }

  ngOnInit() {
    const localStorageData = this._commonAuthService.getLoginData();
    this.studentId = + localStorageData.userId;
    this.studentUserId = this._commonAuthService.getUserId();
    this.getMyCollegeStatusData();

    this.subs.push(
      this._commonDataSharedService.unpinCollege.subscribe(() => {
        this.getMyCollegesData();
      }),
      this._commonDataSharedService.checkPinUnpinCollege.subscribe((data: any) => {
        if (data) {
          this.getMyCollegesData();
        }
      }),
      this._commonDataSharedService.collegeListPageChange.subscribe((data: any) => {
        if (data) {
          this.pageNo = data['pageNumber'];
          this.pageSize = data['pageSize'];
          this.getMyCollegesData();
        }
      })
    );

    this.myFitValue = setInterval(() => {

      this.getMyCollegesData();

    }, 10000);


  }


  getMyCollegeStatusData() {
    const getMyCollegeStatusInputJson = {
      classTypeName: 'Application Status'
    };
    this._commonRequestResponseService.postWithHeader('admin/values', getMyCollegeStatusInputJson)
      .subscribe(
        (myCollegeStatusJSON: any) => {
          this.myCollegeStatusJSON = myCollegeStatusJSON.items;
          this.getHousingPlanData();
        },
        () => {
          this.notificationService.show('info', 'No values data exists for this reference type');
        });
  }

  getHousingPlanData() {

    const getMyCollegeStatusInputJson = {
      classTypeName: 'Student Housing Option'
    };
    this._commonRequestResponseService.postWithHeader('admin/values', getMyCollegeStatusInputJson)
      .subscribe(
        (housingPlanJSON: any) => {
          this.housingPlanJSON = housingPlanJSON.items;
          this.getMyCollegesData();
        },
        () => {
          this.notificationService.show('info', 'No values data exists for this reference type');
        });
  }

  getMyCollegesData() {
    const inputJson = {
      studentUserId: this.studentUserId.toString(),
      page: this.pageNo,
      pagesize: this.pageSize
    };

    this.dataLoaded = true;
    this._commonRequestResponseService.post('student/mycolleges', inputJson)
      .subscribe(
        (collegeJsonData: any) => {
          if (!collegeJsonData.myFitCalculating) {
            clearInterval(this.myFitValue);
          }
          this.collegeJsonData = [];
          this.dataLoaded = false;
          this.totalItems = collegeJsonData.totalItems;
          this.collegeJsonData = collegeJsonData.items.filter(() => !this.saveDataFlag);
        },
        () => {
          this.dataLoaded = false;
          this.notificationService.show('error', 'Error while calling service');
        });
  }
  ngOnDestroy() {
    this.subs.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
    if (this.myFitValue) {
      clearInterval(this.myFitValue);
    }
  }
}
